export const getDimensions = (dimension?: string) => {
  const [width, height] = dimension?.split('x') ?? []
  return {
    width: Number(width) || 0,
    height: Number(height) || 0
  }
}
